import database, {
  firebase,
  membersRef,
  usersRef,
  googleAuthProvider,
  facebookAuthProvider,
} from "../../firebase/config";
import * as actions from "./actionTypes";
import { signupBlockReason } from "../../utils/signupGuard";

export const changeSubscriptionActiveStatus = (status) => ({
  type: actions.USER_CHANGE_SUBSCRIPTION_ACTIVE_STATUS,
  subscriptionActive: status,
});

// iPhone/iPad Safari blocks the Google popup ("auth/popup-blocked" - Paul's screenshot, 8 Oct 2026), so mobile
// browsers use the redirect flow instead, and any browser that blocks the popup falls back to it. The redirect
// flow needs authDomain = bridgechampions.com (set in firebase/config.js) so Safari treats it as first-party.
export const startGoogleLogin = () => {
  return () => {
    // Popup first everywhere (it is what has always worked on desktop); phones whose browser blocks it fall
    // through to the redirect flow below.
    return firebase.auth().signInWithPopup(googleAuthProvider).catch((err) => {
      if (err && (err.code === "auth/popup-blocked" || err.code === "auth/operation-not-supported-in-this-environment")) {
        return firebase.auth().signInWithRedirect(googleAuthProvider).then(() => new Promise(() => {}));
      }
      throw err;
    });
  };
};
export const startFacebookLogin = () => {
  return () => {
    return firebase.auth().signInWithPopup(facebookAuthProvider);
  };
};

export const startEmailAndPasswordLogin = (email, password) => {
  return () => {
    return firebase.auth().signInWithEmailAndPassword(email, password);
  };
};

export const signupEmailAndPasswordLogin = (email, password) => {
  return () => {
    // console.log("IN ACTION SIGNUP W EMAIL");
    // console.log(`EMAIL: ${email}, PASSWORD: ${password}`);
    const blocked = signupBlockReason(email);
    if (blocked) return Promise.reject(Object.assign(new Error(blocked), { code: "bc/signup-blocked" }));
    return firebase.auth().createUserWithEmailAndPassword(email, password);
    //  .catch(err => {
    //    if (err.code === 'auth/email-already-in-use') {
    //// DO ACCOUNT LINKING HERE:
  };
};

export const signOut = () => {
  return () => {
    // Mirror Nav.logout: a post-checkout stash must not outlive the session that made it.
    try {
      localStorage.removeItem("postCheckoutSessionId");
      localStorage.removeItem("lastStripeCheckoutSessionId");
      localStorage.removeItem("postCheckoutExpectedUid");
      localStorage.removeItem("postCheckoutReturnedAt");
    } catch (e) {
      // ignore
    }
    firebase.auth().signOut();
  };
};

export const userLoggedIn = (user) => ({
  type: actions.USER_LOGIN,
  user,
});

export const userLoggedInSubscriptionExpires = (
  subscriptionExpires,
  paymentMethod,
  subscriptionActive,
  trialUsed = false,
  tier = "basic"
) => ({
  type: actions.USER_SET_SUBSCRIPTION_EXPIRES,
  subscriptionExpires,
  paymentMethod,
  subscriptionActive,
  trialUsed,
  tier,
});

export const userLoggedOut = () => ({
  type: actions.USER_LOGOUT,
});

export const authReady = () => ({
  type: actions.AUTH_READY,
});

export const setUser = (user) => {
  return (dispatch) => {
    // database.runTransaction((transaction) => {
    //     return Promise.all([
    //         transaction.get(user_),
    //         transaction.get(dataStats)
    //     ])
    // }).then(([userSnapshot, dataStatsSnapshot]) => {
    //    const userBool = userSnapshot.exists && userSnapshot.data().OK;
    //    const { articlesCount, quizCount } = dataStatsSnapshot.data();
    //    console.log(userBool);
    //    console.log(articlesCount, quizCount);
    //    dispatch(setUserAction(userBool, articlesCount, quizCount));
    // });

    // const references = [usersRef.doc(user.uid), membersRef.doc(user.uid)];
    // return database.runTransaction(t => {
    //     return Promise.all(
    //         references.map(async (element) => {
    //             const doc = await t.get(element)
    //         })
    //     ).then(res => console.log(res));
    // });

    usersRef
      .doc(user.uid)
      .get()
      .then((snapshot) => {
        // Admin flag comes from users/{uid}.OK. If that doc is missing or OK is not true,
        // add the user's UID to adminUidAllowList below (or set users/{uid}.OK = true in Firestore).
        // Admin then gets: no subscribe CTAs, Add Article / create article access.
        const adminUidAllowList = new Set([
          "LGoDI1jEsidKRyN5aVvcTFA8Svb2",
        ]);

        let bool = snapshot.exists && snapshot.data().OK;
        if (!bool && adminUidAllowList.has(user.uid)) {
          bool = true;
        }
        dispatch(setUserAction(bool));
      });
  };
};

export const resetUserProfileBlank = (uid) => {
  return (dispatch) => {
    let user = firebase.auth().currentUser;
    user.updateProfile({
      displayName: "",
      photoURL: "",
    });
  };
};

export const setUserAction = (b) => ({
  type: actions.USER_SET,
  a: b,
});

export const setProfileName = (firstName, surname) => ({
  type: actions.USER_SET_PROFILE_NAME,
  firstName: firstName || "",
  surname: surname || "",
});

export const setBeginnerMode = (enabled) => ({
  type: actions.USER_SET_BEGINNER_MODE,
  beginnerMode: !!enabled,
});
